import {  Paginated } from "@feathersjs/feathers/lib";
import { DataType, IStep, Services, IChoice } from "types";
import { action, computed, makeObservable, observable } from "mobx";
import client from "../feathers";
import { Data } from ".";


export class Choice extends Data<IChoice> implements IChoice {

  course_id:   number  = null;
  column:      number  = null;
  is_correct:  boolean = null;
  quiz_id:     number  = null;
  step_id:     number  = null;
  task_id:     number  = null;
  text:        string  = null;
  is_selected: boolean = null;

  constructor(data: IChoice) {
    // The super constructr takes care of references to the service, validation rules
    // and intialized the base members with mobx decorators
    super(DataType.Choice, data);

    // Since Mobx cannot track derived class objects automatically,
    // the decorators have to be provided manually
    makeObservable(this, {
      course_id:   observable,
      is_correct:  observable,
      column:      observable,
      quiz_id:     observable,
      step_id:     observable,
      task_id:     observable,
      text:        observable,
      is_selected: observable,

      toggleSelect: action,

      isCorrect: computed,
    });

    // Initialize data
    // While the super constructor will call this once,
    // the default values given to members will overwrite this so it has to be called again here.
    this.fromData(data);
  }
  /*******************************************************************************************************************************************
   * Database Access
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Overwrites
   ********************************************************************************************************************************************/

  public static get = async (id?: number): Promise<Choice | Choice[]> => {
    try {
      if(id) {
        return Choice.create(await client.service(Services.Choice).get(id));
      } else {
        const choices: Paginated<IChoice> = await client.service(Services.Choice).find();
        if(!choices.total) return [];
        return choices.data.map(q => Choice.create(q));
      }
    } catch (err) {
      console.error("Failed to load Choicees", err);
      return null;
    }
  }

  public static create(data: IChoice): Choice {
    return new Choice(data);
  }

  protected fromData(data: IChoice): void {
    super.fromData(data);
    this.course_id  = data.course_id && Number(data.course_id);
    this.quiz_id    = data.quiz_id && Number(data.quiz_id);
    this.step_id    = data.step_id && Number(data.step_id);
    this.task_id    = data.task_id && Number(data.task_id);
    this.is_correct = data.is_correct;
    this.text       = data.text;
    this.column     = data.column;
  }

  public toData(): any {
    return {
      ...super.toData(),
      course_id:  this.course_id || null,
      is_correct: this.is_correct || null,
      quiz_id:    this.quiz_id || null,
      step_id:    this.step_id || null,
      task_id:    this.task_id || null,
      text:       this.text || null,
      column:     this.column || null,
    };
  }

  public toPatchData(patch: Partial<IStep>): any {
    return {
      ...super.toPatchData(patch),
      course_id:  "course_id"  in patch ? this.course_id:  undefined,
      is_correct: "is_correct" in patch ? this.is_correct: undefined,
      quiz_id:    "quiz_id"    in patch ? this.quiz_id:    undefined,
      step_id:    "step_id"    in patch ? this.step_id:    undefined,
      task_id:    "task_id"    in patch ? this.task_id:    undefined,
      text:       "text"       in patch ? this.text:       undefined,
      column:     "column"     in patch ? this.column:     undefined,
    };
  }

  /*******************************************************************************************************************************************
   * Getter
   ********************************************************************************************************************************************/

  public get canEdit(): boolean {
    return true;
  }

  public get isCorrect(): boolean {
    return Boolean(this.is_correct);
  }

  /*******************************************************************************************************************************************
   * Setter
   ********************************************************************************************************************************************/

  toggleSelect = () => {
    this.is_selected = !this.is_selected;
  }
  /*******************************************************************************************************************************************
   * Actions
   ********************************************************************************************************************************************/
}
